import FmbmFooter from './FmbmFooter'
import enhance from './FmbmFooter.enhancer'

export default enhance(FmbmFooter)
